<template>
  <div class="assets-center">
	<div class="head-info">
		<p class="rmb-logo"><img src="@assets/images/rmb.png" alt=""></p>
		<p class="assets-t">可提现金额</p>
		<h2 class="assets-num">￥ {{ commissionCount }}</h2>
	</div>
	<div @click="$router.push('/user/user_cash')" class="assets-button">提现</div>
	<ul>
		<li @click="$router.push('/user/inout')">佣金明细<i class="iconfont icon-jiantou"></i></li>
		<li @click="$router.push('/user/cashrecord')">提现记录<i class="iconfont icon-jiantou"></i></li>
	</ul>
  </div>
</template>
<script>
import { getBank } from "../../../api/user";
export default {
  name: "AssetsCenter",
  components: {},
  props: {},
  data: function() {
    return {
      commissionCount:""
    };
  },
  watch: {
    $route(n) {
      if(n.name == 'AssetsCenter') this.getInfo();
    }
  },
  mounted: function() {
    this.getInfo();
  },
  methods: {
    getInfo: function() {
      let that = this;
      getBank().then(res => {
		that.commissionCount = res.data.commissionCount;
	  }).catch(err => {
		that.$dialog.message(err.msg);
		setTimeout(function(){
			that.$router.push('/');  
		},1000);
	  });
    },
    
  }
};
</script>
<style scoped>
.rmb-logo{margin: 0 auto;width: 3.2rem;margin-top: 1rem;}
.rmb-logo img{width: 100%;display: block;}
.assets-t{font-size: 0.3rem;text-align: center;margin-top: 0.38rem;}
.assets-num{text-align: center;margin-top: 0.27rem;font-size: 0.4rem;}
.assets-button{background-color: #20c064;border-radius: 3px;text-align: center;height: 1rem;line-height: 1rem;color: #fff;width: 92%;margin: 0 auto;margin-top: 0.8rem;}
.assets-center ul{padding-left: 0.3rem;background-color: #fff;margin-top: 0.4rem;}
.assets-center ul li{border-bottom: 1px solid #f6f7f8;height: 0.85rem;line-height: 0.85rem;}
.assets-center ul li:last-child{border-bottom: none;}
.assets-center ul li .iconfont{float: right;font-size: 0.26rem;color: #969799;margin-right: 0.3rem;}
</style>
